import styled from 'styled-components';
import {media, tokens} from '../../../theme';


export const MessagesContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    margin-bottom: 20px;
    position: relative;
    background: ${({ theme }) => theme.palette.layout.main};
    padding-right: 4px;

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 3px;
        transition: background-color 0.2s ease-in-out;
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
    }

    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
`;

export const AssistantLogo = styled.img`
    width: 70px;
    height: 100%;
    object-fit: contain;

    ${media.sm} {
        width: 85px;
    }

    ${media.md} {
        width: 90px;
    }
`;


export const MessageRate = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    width: 100%;

    span {
        font-size: 12px;
        color: #d9d9d9;
    }

    img {
        cursor: pointer;
        width: 20px;
        height: 20px;
    }
`;


const BaseDocumentAttachment = styled.div`
    display: flex;
    align-items: center;
    border-radius: ${tokens.radius.lg};
    padding: 5px 10px;
    margin-bottom: 8px;
    width: fit-content;
    gap: 5px;
    border: 1px solid #dde2e6;
`;

export const DocumentAttachmentSystem = styled(BaseDocumentAttachment)<{
    $hasContentSource?: boolean;
}>`
    background: rgba(224, 224, 224, 0.4);
    margin-bottom: 0;
    border-radius: ${tokens.radius.lg};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    
    gap: 7px;
    border: none;
    padding: 5px 12px;
    
    justify-content: space-between;
    width: fit-content;
    max-width: 100%;
    
    ${({ $hasContentSource }) =>
        $hasContentSource &&
        `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: ${tokens.radius.lg};
    `}

    ${media.sm} {
        max-width: 90%;
        padding: 5px 16px;
    }

    ${media.md} {
        max-width: 80%;
    }
`;

export const DocumentAttachmentYou = styled(BaseDocumentAttachment)`
    background: rgba(224, 224, 224, 0.4);
    margin-bottom: 0;
    border-radius: ${tokens.radius.lg};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    
    gap: 7px;
    border: none;
    padding: 5px 12px;
    justify-content: space-between;
    width: fit-content;
    max-width: 100%;

    ${media.sm} {
        max-width: 90%;
        padding: 5px 16px;
    }

    ${media.md} {
        max-width: 80%;
    }
`;

export const DocumentAttachment = styled.div`
    display: flex;
    align-items: center;
    background: #f0f0f0;
    border-radius: ${tokens.radius.lg};
    
    padding: 5px 10px;
    margin-bottom: 8px;
    width: fit-content;
    gap: 5px;
    border: 1px solid #dde2e6;
`;

export const DocumentContentSourceSystem = styled(BaseDocumentAttachment)<{
    $hasAttachment?: boolean;
}>`
    background: rgba(224, 224, 224, 0.4);
    margin-bottom: 0;
    border-radius: 16px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    
    gap: 7px;
    border: none;
    padding: 5px 12px;
    justify-content: space-between;
    ${({ $hasAttachment }) =>
        $hasAttachment &&
        `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 16px;
    `}

    ${media.sm} {
        padding: 5px 16px;
    }
`;

export const MessageFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 32px;
`;
